import { useDispatch, useSelector } from "react-redux";

import useNavigateToVorViewerRow from "pages/EstimateViewer/VorViewer/hooks/useNavigateToVorViewerRow";
import { getItemQtfLink } from "slices/local_estimate";
import { getProjectMainData } from "slices/project_work";

const CustomNumCell = ({ rowObj }) => {
	const dispatch = useDispatch();
	const project = useSelector(getProjectMainData);
	const { openVorRowByKey } = useNavigateToVorViewerRow();

	let cellCenterLabel = rowObj.num == null ? "" : rowObj.num.toString();
	let cellCenter = <span className="CustomNumCellCenter">{cellCenterLabel}</span>;

	let cellLeft = <span className="CustomNumCellLeft"></span>;
	let cellRight = <span className="CustomNumCellRight"></span>;

	if (rowObj.is_item === "1") {
		if (rowObj.has_cost) {
			let sumTypeShort = "";
			let cellTitle = rowObj.summarytype;
			if (rowObj.is_calculation === true) {
				sumTypeShort = "КАЛК";
				cellTitle = "Калькуляция";
			} else if (rowObj.summarytype === "Строительные") {
				sumTypeShort = "СТР";
			} else if (rowObj.summarytype === "Монтажные") {
				sumTypeShort = "МОН";
			} else if (rowObj.summarytype === "Прочее") {
				sumTypeShort = "ПРЧ";
			}
			cellRight = (
				<span className="CustomNumCellRight" title={cellTitle}>
					{sumTypeShort}
				</span>
			);
		}
	}

	if (rowObj.is_item === "1" || rowObj.protectable === true) {
		if (rowObj.model_name === "LocalEstimatesResMaterial") {
			cellRight = (
				<span className="CustomNumCellRight" title="Материал">
					МАТ
				</span>
			);
		} else if (rowObj.model_name === "LocalEstimatesResEquipment") {
			cellRight = (
				<span className="CustomNumCellRight" title="Оборудование">
					ОБ
				</span>
			);
		} else if (rowObj.model_name === "LocalEstimatesResMachine") {
			cellRight = (
				<span className="CustomNumCellRight" title="Машины и механизмы">
					МЕХ
				</span>
			);
		} else if (rowObj.model_name === "LocalEstimatesResTransport") {
			cellRight = (
				<span className="CustomNumCellRight" title="Перевозка">
					ПГ
				</span>
			);
		} else if (rowObj.model_name === "LocalEstimatesResOther") {
			cellRight = (
				<span className="CustomNumCellRight" title="Прочие">
					ПРЧ
				</span>
			);
		}
	}

	const getVorLink = () => {
		dispatch(getItemQtfLink({ projectId: project.id, itemId: rowObj.item_id })).then((data) => {
			openVorRowByKey({ projectId: project.id, vorId: data?.payload?.vor_id, key: data?.payload?.work_key });
		});
	};

	if (rowObj.must_be_vor_link === true) {
		cellCenterLabel = "";
		if (rowObj.vor_link === null) {
			cellCenter = (
				<span
					className="CustomNumCellCenter"
					title="Ссылка на ВОР не указана"
					style={{ fontSize: "10px", fontWeight: 600, color: "#c9c9c9", textDecoration: "none", fontStyle: "italic" }}
				>
					ВОР
				</span>
			);
		} else {
			cellCenter = (
				<span
					className="CustomNumCellCenter"
					title={rowObj.vor_link}
					style={{ fontSize: "10px", fontWeight: 600, color: "var(--alert-icon-color)", textDecoration: "underline", fontStyle: "italic" }}
					onClick={(e) => getVorLink()}
				>
					ВОР
				</span>
			);
		}
	}

	return (
		<td
			key={`cell-num-${rowObj.key}`}
			className="TableCell"
			clm="num"
			treecell="false"
			style={{
				paddingLeft: "5px",
			}}
			title={cellCenterLabel}
		>
			<div className="CustomNumCell">
				{cellLeft}
				{cellCenter}
				{cellRight}
			</div>
		</td>
	);
};

export { CustomNumCell };
